import { Node, mergeAttributes } from '@tiptap/core';

export const PensamientoAudio = Node.create({
  name: 'audio',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      title: { default: 'Nota de voz' },
    };
  },

  parseHTML() {
    return [{ tag: 'audio' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'audio',
      mergeAttributes(
        {
          controls: 'true',
          preload: 'metadata',
          class: 'pensamiento-audio',
        },
        HTMLAttributes
      ),
    ];
  },

  addCommands() {
    return {
      setAudio: (attrs) => ({ commands }) => commands.insertContent({
        type: this.name,
        attrs,
      }),
    };
  },
});

export default PensamientoAudio;
